import { useEffect, useMemo } from 'react';

/**
 * Custom hook to scroll to top of page
 * @param {boolean} shouldScroll - Whether to trigger scroll to top
 * @param {Object} options - Scroll behavior options
 */
const useScrollToTop = (shouldScroll = true, options = {}) => {
  const defaultOptions = useMemo(() => ({
    top: 0,
    behavior: 'smooth',
    ...options
  }), [options]);

  useEffect(() => {
    if (shouldScroll) {
      window.scrollTo(defaultOptions);
    }
  }, [shouldScroll, defaultOptions]);

  // Return function to manually trigger scroll
  const scrollToTop = () => {
    window.scrollTo(defaultOptions);
  };

  return scrollToTop;
};

export default useScrollToTop;